export default __webpack_public_path__ + "images/OT.bc5445a.png";